import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

const Campaigns = () => {
    const [campaigns, setCampaigns] = useState([])
    // eslint-disable-next-line
    const [realPage, setRealPage] = useState(0)

    useEffect(() => {
        async function getOffers() {
            try {
                const res = await fetch(process.env.REACT_APP_SERVER_URL + `/user/campaigns/`, { credentials: 'include' });
                const data = await res.json();
            
                setCampaigns(data)
            } catch (e) {
                setCampaigns([])
                return
            }
        }
        
        getOffers()
    }, [realPage])

    function getStatusColor(status) {
        if (status === 'pending') return 'blue'
        if (status === 'rejected') return 'red'
        if (status === 'approved') return 'green'
    }


    return (
        <>

            <div className='orders-container'>
                <p className='title'>Campaigns</p>

                <table>
                    <thead>
                        <tr className='blue'>
                            <th>ID</th>
                            <th>Name</th>
                            <th>CPV</th>
                            <th>Click Left</th>
                            <th>Total Clicks</th>
                            <th>Tokens Spent</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Array.isArray(campaigns) && campaigns.map((campaign, index) => (
                            <tr className='row' key={campaign._id}>
                                <td>{campaign._id}</td>
                                <td>{campaign.campaign_name}</td>
                                <td>{Number(campaign.campaign_cpv)*1000} ad tokens</td>
                                <td>{campaign.campaign_uses_remaining}</td>
                                <td>{campaign.campaign_uses_total}</td>
                                <td>{campaign.tokens_spent}</td>
                                <td className={getStatusColor(campaign.status)}>{(campaign.status)}</td>
                                <td>{new Date(campaign.campaign_created).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <style jsx>{`
                .orders-container {
                    width: 100%;

                    background-color: #141A31;
                    padding: 15px;
                }

                .title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: 600;
                    color: #F1C475;
                    margin: unset;
                }

                table {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }

                tr {
                    width: 100%;
                    display: flex;
                    margin-top: 15px;
                    min-height: 30px;
                    height: 30px;
                    min-height: 30px;
                    border-radius: 6px;
                }

                td, th {
                    flex: 1;
                    text-align: center;
                    overflow-x: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .row {
                    background-color: #21284C;
                    box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
                }

                .green {
                    color: #4FAC7C;
                }

                .red {
                    color: #ac4f4f;
                }

                .blue {
                    color: #4F8DDE;
                }

                .clickable {
                    cursor: pointer;
                }

                .order-view {
                    height: 100%;
                    width: 100%;
                    background-color: rgba(0,0,0,0.5);

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    position: fixed;

                    z-index: 1001;
                    top: 0;
                    left: 0;

                    animation: fadein .2s linear;
                }
                
                .order-center {
                    background-color: #21294D;

                    width: 500px;
                    height: 200px;
                    border-radius: 12px;
                    
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    gap: 10px;
                }

                p {
                    margin: unset;
                }
                
                @keyframes fadein {
                    0% { opacity: 0; }
                    100% { opacity: 1; }
                }
            `}</style>
        </>
    )
}

export default Campaigns